module.exports = __webpack_public_path__ + "img/Pronto_Logo H_negro 1.7d420668.png";